<div class="organization-modal modal-content" piqetAngularDraggable>
  <div class="modal-header">
    <span class="bootstrap-dialog-title">
      {{ modalLabel }}
    </span>

    <button type="button" class="closeModal pull-right" aria-label="Close" (click)="onClose()">
      <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
    </button>
  </div>

  <div class="modal-body body-modal">
    <div [formGroup]="templateForm">
      <div class="row">
        <!-- Template Name -->
        <div class="col-12">
          <div class="form-group required">
            <div class="services-form">
              <input
                type="text"
                name="name"
                placeholder="Name"
                formControlName="templateName"
                [disabled]="isViewMode"
              />
              <label>Template name</label>
            </div>
            <div
              *ngIf="
                templateForm.get('templateName')?.touched &&
                templateForm.get('templateName')?.hasError('required')
              "
              class="error-messages"
            >
              Template name is required.
            </div>
          </div>
        </div>

        <!-- Subject -->
        <div class="col-12">
          <div class="form-group required">
            <div class="services-form">
              <input
                type="text"
                name="subject"
                placeholder="Subject"
                formControlName="subject"
                [disabled]="isViewMode"
              />
              <label>Subject</label>
            </div>
            <div
              *ngIf="
                templateForm.get('subject')?.touched &&
                templateForm.get('subject')?.hasError('required')
              "
              class="error-messages"
            >
              Subject is required.
            </div>
          </div>
        </div>

        <!-- Tags -->
        <div class="col-12">
          <div class="form-group">
            <div class="services-form" *ngIf="!isViewMode">
              <input
                type="text"
                class="form-control"
                placeholder="Add tag and press Enter"
                (keydown.enter)="addTag($event)"
              />
              <label>Tags</label>
            </div>
            <small class="tag-helper-text" *ngIf="!isViewMode">
              Press <b>Enter</b> to add a tag or separate tags using <b>commas (,)</b>.
            </small>
            <div class="tag-container">
              <span class="tag" *ngFor="let tag of tags">
                {{ tag }}
                <span class="remove-tag" *ngIf="!isViewMode" (click)="removeTag(tag)">×</span>
              </span>
            </div>
            <div *ngIf="duplicateTagError" class="error-messages">Tag already exists.</div>
          </div>
        </div>

        <!-- Placeholder Link -->
        <div class="col-12 d-flex justify-content-end" *ngIf="!isViewMode">
          <a
            class="add-link"
            target="_blank"
            routerLink="/administrator/emailConfiguration/templates/placeholders"
          >
            <span class="redirectLinkText">View Available Placeholders</span>
          </a>
          <a
            class="setLinkIconPosition"
            target="_blank"
            replaceUrl="true"
            routerLink="/administrator/emailConfiguration/templates/placeholders"
          >
            <img src="./assets/icons/redirect-icon.svg" alt="" width="15" height="13" />
          </a>
        </div>

        <!-- CKEditor Body -->
        <div class="col-12">
          <div class="form-group">
            <ng-container *ngIf="!isViewMode; else viewBody">
              <ckeditor
                [(ngModel)]="ckeEditorValue"
                formControlName="body"
                (input)="changeEve($event)"
                [config]="ckEditorConfig"
              >
              </ckeditor>
              <div *ngIf="templateForm.get('body')?.hasError('required')" class="error-messages">
                Body cannot be empty.
              </div>
            </ng-container>

            <!-- View-only rendered HTML content -->
            <ng-template #viewBody>
              <div class="rendered-html" [innerHTML]="ckeEditorValue"></div>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Footer Buttons -->
  <div class="modal-footer text-margin">
    <button type="button" class="cancelBtn" (click)="onClose()">Cancel</button>
    <button
      *ngIf="!isViewMode"
      type="button"
      class="modelBtn purpleBtnHoverEffect"
      [disabled]="!templateForm.valid"
      (click)="onSave()"
    >
      Save
    </button>
  </div>
</div>
